import { useMemo } from "react"
import { useQuery } from "@rocicorp/zero/react"

import { queries } from "@productlane/zero/queries"

import { api } from "@/lib/api"
import { isQuerySettled } from "@/lib/query-settled"

// MCP connectors render no sidebar card, and an admin can hide an HTTP one
// (a huge database card the AI still reads).
export function visibleSidebarSections<T extends { id: string; type: string }>(
	sections: readonly T[],
	hiddenIds: readonly string[],
): T[] {
	const hidden = new Set(hiddenIds)
	return sections.filter(
		(section) => section.type === "HTTP" && !hidden.has(section.id),
	)
}

export function useSidebarConnectors() {
	const [allSections, allSectionsResult] = useQuery(queries.sidebarSections())
	const hidden = api.customData.hiddenSidebarSections.useQuery(undefined, {
		staleTime: 60_000,
	})
	const sections = useMemo(
		() => visibleSidebarSections(allSections, hidden.data ?? []),
		[allSections, hidden.data],
	)
	// Waits for the hidden list, so a hidden card never flashes in; an error
	// fails open and shows every card.
	const settled = isQuerySettled(allSectionsResult) && !hidden.isLoading
	return { sections, settled }
}
